// Shared Play Store URL with UTM tracking for blog download attribution
// All Play Store links across blog components must import from this constant
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.billbytekot' +
  '&utm_source=blog&utm_medium=cta&utm_campaign=playstore';
